import initialState from './initial.state';
import * as types from '../actions/types.action';

const resetBasketItem = (meal, uuid, origin) => {
  return {
    mealUuid: meal.uuid,
    price: meal.price,
    quantity: 1,
    size: meal.sizes[0].name,
    selectedOptions: [],
    comments: '',
    uuid: uuid || null,
    origin
  };
};

const resetBasketItemOriginalState = () => {
  return initialState.basketItem;
};

const updateOptionsAndPrice = (state, action) => {
  let updatedOptions;
  const newOptions = action.mealOptions.selectedOptions;
  const selectedOptions = state.selectedOptions;

  const checkOptionExisted = option => {
    return option.group === newOptions.group && option.selection === newOptions.selection;
  };

  const checkOptionGroupExisted = option => {
    return option.group === newOptions.group;
  };

  if (!action.mealOptions.multiSelect) {
    const index = selectedOptions.findIndex(checkOptionGroupExisted);

    if (index > -1) {
      updatedOptions = [
        ...selectedOptions.slice(0, index),
        newOptions,
        ...selectedOptions.slice(index + 1)
      ];
    } else {
      updatedOptions = [
        newOptions,
        ...selectedOptions
      ];
    }
  } else if (selectedOptions.some(checkOptionExisted)) {
    const pos = selectedOptions.findIndex(checkOptionExisted);

    if (pos > -1) {
      updatedOptions = [
        ...selectedOptions.slice(0, pos),
        ...selectedOptions.slice(pos + 1)
      ];
    } else {
      updatedOptions = [
        newOptions,
        ...selectedOptions
      ];
    }
  } else if (action.mealOptions.isMaxSelectableOne) { // it should deselect another option when max selectable is one
    const index = selectedOptions.findIndex(checkOptionGroupExisted);
    if (index > -1) {
      updatedOptions = [
        ...selectedOptions.slice(0, index),
        newOptions,
        ...selectedOptions.slice(index + 1)
      ];
    } else {
      updatedOptions = [
        newOptions,
        ...selectedOptions
      ];
    }
  } else {
    updatedOptions = [
      newOptions,
      ...selectedOptions
    ];
  }

  const price = updatedOptions.map(e => e.price)
    .reduce((acc, val) => {
      return val ? acc + val * 100 : acc;
    }, action.mealOptions.basicPrice * 100 || 0);

  return Object.assign({}, state, {
    selectedOptions: updatedOptions,
    price: Math.round(price) * state.quantity / 100
  });
};

const updateSize = (state, action) => {
  return Object.assign({}, state, {
    size: action.size.name,
    price: action.size.price,
    selectedOptions: []
  });
};

const updateQuantity = (state, action) => {
  const newPrice = (Math.round(state.price * 100) / state.quantity) * action.quantity;
  return Object.assign({}, state, {
    quantity: action.quantity,
    price: Math.round(newPrice) / 100
  });
};

const updateExitingBasketItem = (state, action) => {
  const {mealUuid, price, selectedOptions, quantity, size, uuid, comments, promotion, origin} = action.basketItem;
  return {
    mealUuid,
    price,
    quantity,
    size,
    selectedOptions,
    comments,
    uuid,
    promotion,
    origin
  };
};

const updateBasketItemComments = (state, action) => {
  return Object.assign({}, state, {
    comments: action.comments
  });
};

export default function basketItemReducer(state = initialState.basketItem, action) {
  switch (action.type) {
    case types.RESET_BASKET_ITEM_SUCCESS:
      return resetBasketItem(action.meal, action.uuid, action.origin);

    case types.UPDATE_BASKET_ITEM_SIZE_SUCCESS:
      return updateSize(state, action);

    case types.UPDATE_BASKET_ITEM_OPTIONS_SUCCESS:
      return updateOptionsAndPrice(state, action);

    case types.RESET_BASKET_ITEM_ORIGINAL_STATE_SUCCESS:
      return resetBasketItemOriginalState();

    case types.UPDATE_BASKET_ITEM_QUANTITY_SUCCESS:
      return updateQuantity(state, action);

    case types.LOAD_EXISTING_BASKET_ITEM_SUCCESS:
      return updateExitingBasketItem(state, action);

    case types.UPDATE_BASKET_ITEM_COMMENTS_SUCCESS:
      return updateBasketItemComments(state, action);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/basketItem.reducer.js